import(/* webpackMode: "eager" */ "/home/runner/work/nextjs-asktraining.com.sg/nextjs-asktraining.com.sg/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/nextjs-asktraining.com.sg/nextjs-asktraining.com.sg/src/app/styles/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredStyle"] */ "/home/runner/work/nextjs-asktraining.com.sg/nextjs-asktraining.com.sg/src/components/DeferredStyle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/nextjs-asktraining.com.sg/nextjs-asktraining.com.sg/src/components/SearchDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/nextjs-asktraining.com.sg/nextjs-asktraining.com.sg/src/components/SearchForm.tsx");
